module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "book"
  }, [_c('div', {
    staticClass: "coverInfo"
  }, [_c('img', {
    staticClass: "coverImage",
    attrs: {
      "src": "//textcafe.co/books/ZCpNHe/images/cover.jpg?1685327317466",
      "alt": "This image is the cover for the book Another Way, Another Way..."
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "bookInfo"
  }, [_c('h1', {
    staticClass: "bookTitle heading font1"
  }, [_vm._v("Another Way, Another Way...\n    ")]), _vm._v(" "), _c('p', {
    staticClass: "bookDescription body article font2"
  }), _c('p', [_c('b', [_c('i', [_vm._v("An Another Way... Story")])])]), _c('p', [_vm._v("On the surface, Jesse Ross is an average guy in an average relationship with his college sweetheart, Adele. But what his girlfriend doesn’t know is that he’s having an affair—with a man—and exploring his sexuality in ways she never could imagine. His compartmentalized life suits Jesse just fine, and he has no intention of coming out of the closet either as a bisexual or as a submissive.")]), _vm._v(" "), _c('p', [_vm._v("However, Jesse takes a tumble when his Master, Will, admits to wanting more, wanting Jesse as his partner, not just his submissive. Suddenly Jesse's conveniently pieced-together life isn’t quite so comfortable. In the end, Jesse has to lay it all on the line—for his girlfriend, for his lover, and for himself.")]), _vm._v(" "), _c('p')]), _vm._v(" "), _c('div', {
    staticClass: "authorInfo"
  }, [_c('h2', {
    staticClass: "authorName heading font1"
  }, [_vm._v("\n      Anna Martin\n    ")])]), _vm._v(" "), _c('div', {
    staticClass: "publisherInfo"
  }, [_c('h2', {
    staticClass: "publisherName heading font1"
  })])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-638a3f51","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/home.vue
// module id = 51
// module chunks = 0